import styled from 'styled-components';

export const Wrapper = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  box-sizing: border-box;
  width: 295px;
  border: 1px solid ${({ theme }) => theme.colors.neutral['200']};
  border-bottom-width: 0;
`;

export const Content = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
`;

export const ApexStatus = styled.span`
  @keyframes pulseColor {
    from {
      opacity: 1;
    }
    to {
      opacity: 0.5;
    }
  }

  border-radius: 50%;
  height: 5px;
  width: 5px;
  background: #e4433d;
  display: inline-block;

  animation-name: pulseColor;
  animation-duration: 1s;
  animation-timing-function: ease-out;
  animation-delay: 0s;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  animation-fill-mode: none;
  animation-play-state: running;
`;
